import React, {useEffect, useRef, useState} from "react";

function UserGroupMenuTreeNode({menu, depth, groupMenus, onChangeHandler}) {
    const [collapsed, setCollapsed] = useState(false);
    const checkRef = useRef(null);
    const hasChildren = menu.children?.length > 0;

    useEffect(() => {
        if (!menu || !checkRef.current) {
            return;
        }
        checkRef.current.checked = groupMenus?.includes(menu.id) ?? false;
        checkRef.current.indeterminate = false;
    }, [menu, groupMenus]);

    const toggleCollapsed = () => {
        if (hasChildren) {
            setCollapsed((prev) => !prev);
        }
    };

    return (
        <div className="user-group-menu-tree">
            <div className={`user-group-menu-tree__row user-group-menu-tree__row--depth-${Math.min(depth, 2)}`}>
                <div className="user-group-menu-tree__label">
                    {hasChildren ? (
                        <button
                            type="button"
                            className="user-group-menu-tree__toggle"
                            aria-label={collapsed ? "펼치기" : "접기"}
                            onClick={toggleCollapsed}
                        >
                            {collapsed ? "▶" : "▼"}
                        </button>
                    ) : (
                        <span className="user-group-menu-tree__toggle-spacer" aria-hidden />
                    )}
                    <span
                        className="user-group-menu-tree__name"
                        onClick={toggleCollapsed}
                        onKeyDown={(e) => {
                            if (e.key === "Enter" || e.key === " ") {
                                toggleCollapsed();
                            }
                        }}
                        role={hasChildren ? "button" : undefined}
                        tabIndex={hasChildren ? 0 : undefined}
                    >
                        {menu.name}
                    </span>
                </div>
                <label className="user-group-menu-tree__check">
                    <input
                        type="checkbox"
                        ref={checkRef}
                        onChange={() => onChangeHandler(menu)}
                    />
                </label>
            </div>

            {hasChildren && !collapsed && (
                <div className="user-group-menu-tree__children">
                    {menu.children.map((child) => (
                        <UserGroupMenuTreeNode
                            key={child.id}
                            menu={child}
                            depth={depth + 1}
                            groupMenus={groupMenus}
                            onChangeHandler={onChangeHandler}
                        />
                    ))}
                </div>
            )}
        </div>
    );
}

export default UserGroupMenuTreeNode;
